// extracted by mini-css-extract-plugin
export default {"shareHeading":"ShareButtonGroup_shareHeading__LTJQ1","line":"ShareButtonGroup_line__ftobc","shareText":"ShareButtonGroup_shareText__EfXzv"};